<div class="d-flex justify-content-between align-items-center mb-2 px-2">
	<h2>{{'nav.blocked_devices' | translate}}</h2>
	<div>
		<button class="btn btn-primary mx-2" type="button" [disabled]="!selectedMacAddresses.length" (click)="unblockConfirmationPopup.show()">{{'devices.unblock_selected' | translate}}</button>
		<button class="btn btn-primary" type="button" (click)="exportToCsv()">{{'g.export_to_csv' | translate}}</button>
	</div>
</div>

<sct-custom-table
	#sctCustomTable
	[columnsConfig]="columnConfig"
	[data]="tableData"
	[config]="tableConfig"
	(updateSelectedRows)="updateSelectedDevices($event)"
></sct-custom-table>

<app-modal
	#unblockConfirmationPopup
	title="{{'g.confirmation' | translate}}"
	closeBtnText="g.cancel"
	size="md"
>
	<p>{{'devices.unblock_devices_confirm_message' | translate: {count: selectedMacAddresses.length} }}</p>
</app-modal>
